import { IS_MOBILE } from '@repo/common-utils';

export const openKakaoTalk = (cxId: string) => {
  if (IS_MOBILE) {
    const kakaoLink = `kakaotalk://me/cert/sign?tx_id=${cxId}`;
    window.location.href = kakaoLink;
  }
};
